// telas/Recebe.tsx - "O que você vai receber", ao lado do pedido no computador (07_VOZ §5; D83).

import type { ComponentType } from 'react';
import { IconAccessibility, IconFileDown, IconLightbulb, IconListOrdered, type IconProps } from '@winieduca/ui';
import { recebe, recebeApoio } from '../content/textos';

const ITENS: { icone: ComponentType<IconProps>; titulo: string; apoio: string }[] = [
  { icone: IconListOrdered, titulo: recebe.passo, apoio: recebeApoio.passo },
  { icone: IconAccessibility, titulo: recebe.dicas, apoio: recebeApoio.dicas },
  { icone: IconLightbulb, titulo: recebe.porque, apoio: recebeApoio.porque },
  { icone: IconFileDown, titulo: recebe.pdf, apoio: recebeApoio.pdf },
];

export function Recebe() {
  return (
    <aside className="din-recebe" aria-labelledby="recebe-titulo">
      <h2 id="recebe-titulo" className="we-h2">
        {recebe.titulo}
      </h2>
      <ul className="din-recebe__lista">
        {ITENS.map(({ icone: Icone, titulo, apoio }) => (
          <li key={titulo} className="din-recebe__item">
            <Icone className="din-recebe__icone" />
            <span className="din-recebe__titulo">{titulo}</span>
            <span className="din-recebe__apoio">{apoio}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
